<app-header></app-header>
<div class="page-title-area page-title-style-two item-rights bg-auction">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Declaratii de avere si interese 2022</li>
            </ul>
            <h2>Declaratii de avere si interese 2022</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2>Declaratii de avere si interese 2022</h2>
                <table>
                    <tr>
                        <td>Radulescu-Barbulet Serban-Nicolae</td>
                        <td>Director General</td>

                        <td>
                            <a
                                href="assets/img/pdf/Radulescu Serban.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Negreanu Ana Matia</td>
                        <td>Director Medical</td>

                        <td>
                            <a
                                href="assets/img/pdf/Negreanu Ana Maria.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Adriana Pop</td>
                        <td>Director Laborator</td>

                        <td>
                            <a
                                href="assets/img/pdf/Adriana Pop.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Anghel Alexandru</td>
                        <td>Director Administrativ</td>

                        <td>
                            <a
                                href="assets/img/pdf/Anghel Alexandru.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Anghel Camelia</td>
                        <td>Sef Birou Juridic</td>

                        <td>
                            <a
                                href="assets/img/pdf/Anghel Camelia.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Badiceanu Sofronie</td>
                        <td>Sef Sectie Medicina Preventiva</td>

                        <td>
                            <a
                                href="assets/img/pdf/Badiceanu Sofronie.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Bulugu Danut</td>
                        <td>Director Economic</td>

                        <td>
                            <a
                                href="assets/img/pdf/Bulugu Danut.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Cristescu Valentin</td>
                        <td>Director Tehnic</td>

                        <td>
                            <a
                                href="assets/img/pdf/Cristescu Valentin.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Enache Carmen</td>
                        <td>Sef Serviciu Raportari, Avize, Acreditari</td>

                        <td>
                            <a
                                href="assets/img/pdf/Enache Carmen.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Lungu Claudia</td>
                        <td>Sef Birou Salarizare</td>
                        <td>
                            <a
                                href="assets/img/pdf/Lungu Claudia.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Moreanu Cristina</td>
                        <td>Sef Birou Achizitii Publice</td>

                        <td>
                            <a
                                href="assets/img/pdf/Moreanu Cristina.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Nita Claudia</td>
                        <td>Farmacist Sef</td>

                        <td>
                            <a
                                href="assets/img/pdf/Nita Claudia.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Petre Viorel</td>
                        <td>Sef Birou Administrativ</td>

                        <td>
                            <a
                                href="assets/img/pdf/Petre Viorel.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Ticu-Similschi Laura-Marina</td>
                        <td>Contabil Sef</td>

                        <td>
                            <a
                                href="assets/img/pdf/Ticu-Similschi Laura-Marina.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Tomasescu Niculina</td>
                        <td>Asistent Sef</td>

                        <td>
                            <a
                                href="assets/img/pdf/Tomasescu Niculina.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>Vesei Doru Lucian</td>
                        <td>Presedinte Consiliu Administrativ</td>

                        <td>
                            <a
                                href="assets/img/pdf/Vesei Doru.pdf"
                                download
                                >rectificativa</a
                            >
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
